<template>
	<el-container>
		<el-header>
			<div class="logo">
				<img @click="home()" src="https://qtfile.xdf.cn/template/image/logo1_0.png" alt="新东方前途出国">
			</div>
			<div class="header_r" v-if="isShow">
				<a class="preview flex" href="/webnpdp/file/handbook.pdf" target="_blank">
					<el-icon :size="20"><Document /></el-icon>
					手册
				</a>
				<div class="bell flex" @click="readnotices()">
					<el-icon :size="20">
						<Bell />
						<span v-if="!notices.status"></span>
					</el-icon>
					公告
				</div>
				<div class="user flex" v-if="user.data.nickName!=''">
					<el-avatar class="avatar" :size="30">
						<el-icon :size="20"><Avatar /></el-icon>
					</el-avatar>
					<span class="name">{{user.data.nickName}}</span>
					<el-dropdown>
						<el-icon @click="q_logout()" class="logout" :size="12" color="#000">
							<Right />
						</el-icon>
					</el-dropdown>
				</div>
			</div>
		</el-header>
		<el-drawer v-model="drawer" title="系统更新日志">
			<ul v-if="notices.notice!=''">
				<li v-html="notices.notices"></li>
			</ul>
			<el-empty v-else description="暂无数据"></el-empty>
		</el-drawer>
		<el-container class="container" v-loading="!isShow">
			<el-aside>
				<el-scrollbar>
					<el-menu class="menu_wrap" :default-active="user.data.rolePermission.defaultActive" :unique-opened="true" :router="true">
						<div v-for="(data,i) in user.data.rolePermission.menuList">
							<el-menu-item v-if="data.route!=''" :index="String(i)" :route="data.route">
								<el-icon><component :is="data.icon"/></el-icon>
								<span>{{data.name}}</span>
							</el-menu-item>
							<el-sub-menu v-else :index="String(i)">
								<template #title>
									<el-icon><component :is="data.icon"/></el-icon>
									<span>{{data.name}}</span>
								</template>
								<el-menu-item-group v-if="data.item.length>0">
									<el-menu-item v-for="(item,j) in data.item" :index="i+'-'+j" @click="goToPage" :route="item.route">{{item.name}}</el-menu-item>
								</el-menu-item-group>
							</el-sub-menu>
						</div>
					</el-menu>
				</el-scrollbar>
			</el-aside>
			<el-scrollbar class="main_wrap">
				<el-main>
					<RouterView v-if="isShow" />
				</el-main>
			</el-scrollbar>
		</el-container>
	</el-container>
</template>

<script>
	import http from '@/api/http';
	import {RouterView} from 'vue-router'
	import {useUserStore,regionStore} from './stores/counter'
	import {getUserRoleInfo,logout} from '@/api/login.js'
	import {getCompanyList} from '@/utils/ajax.js'

	export default {
		data() {
			return {
				user:{},
				notices:{
					status:true
				},
				drawer: false,
				isShow:false
			}
		},
		created() {
			const user = useUserStore()
			this.user = user
			getUserRoleInfo()
			getCompanyList(function(data){
				let region = []
				data.forEach((v,i)=>{
					region.push({
						value: v.companyName,
						label: v.companyName,
					})
				})
				regionStore().$patch((state) => {
					state.region = region
				})
			})
		},
		methods: {
			home() {
				this.$router.push({
					path: '/'
				})
				const user = useUserStore()
				user.$patch((state) => {
					state.data.rolePermission.defaultActive = '0'
				})
			},
			q_logout() {
				logout()
			},
			goToPage(){
				this.isShow = false 
				this.$nextTick(() => {
					setTimeout(()=>{
						this.isShow = true
					},50)
				})
			},
			getNotices(){
				http.get('/npdp/base/get-new-notices', {}).then(response=>{
					if( response.code=='2001' ){
						this.notices = response.data
					}
				});
			},
			readnotices(){
				this.drawer = true
				if( !this.notices.status ){
					http.post('/npdp/base/read-new-notices?nId='+this.notices.nId, {}).then(response=>{
						this.notices.status = true
					});
				}
			}
		},
		watch:{
			$route:{
				handler(val,oldval){
					for( var i=0;i<this.user.data.rolePermission.menuList.length;i++ ){
						for( var j=0;j<this.user.data.rolePermission.menuList[i].item.length;j++ ){
							if( this.user.data.rolePermission.menuList[i].item[j].route==this.$route.path ){
								this.user.data.rolePermission.defaultActive = i+'-'+j
								break
							}
						}
					}
				},
				// 深度观察监听
				deep: true
			},
			user:{
				handler(val,oldval){
					const menuList = val.data.rolePermission.menuList
					if( menuList.length>0 ){
						this.isShow = true
						let flag = true;
						for( var i=0;i<menuList.length;i++ ){
							for( var j=0;j<menuList[i].item.length;j++ ){
								if( '/webnpdp'+menuList[i].item[j].route==window.location.pathname ){
									const user = useUserStore()
									user.$patch((state) => {
										state.data.rolePermission.defaultActive = i+'-'+j
									})
									flag = false
									break
								}
							}
						}
						if( flag ){
							this.$router.push({path:'/'})
							const user = useUserStore()
							user.$patch((state) => {
								state.data.rolePermission.defaultActive = '0'
							})
						}
					}
				},
				deep: true
			},
			isShow:{
				handler(val,oldval){
					if( val ){
						this.getNotices()
					}
				},
				deep: true
			}
		}
	}
</script>

<style scoped>
	.el-container {
		height: 100%;
	}
	.el-container .el-header {
		height: 64px;
		color: #767676;
		background-color: #fff;
		border-bottom: 1px solid #ebebeb;
		position: relative;
	}
	.el-container .el-header .logo {
		width: 170px;
		height: 100%;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}
	.el-container .el-header .logo img {
		width: 100%;
	}
	.el-container .el-header .avatar{
		margin-right: 4px;
	}
	.el-container .el-header .header_r{
		width: auto;
		height: 100%;
		font-size: 14px;
		line-height: 24px;
		color: #595959;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		float: right;
		margin: 0 20px;
	}
	.el-container .el-header .header_r a{
		color: #595959;
		text-decoration: auto;
	}
	.el-container .el-header .header_r .flex{
		margin-right: 30px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
	}
	.el-container .el-header .header_r .flex .el-icon{
		margin-right: 4px;
	}
	.el-container .el-header .header_r .bell{
		cursor: pointer;
	}
	.el-container .el-header .header_r .bell .el-icon span{
		width: 10px;
		height: 10px;
		line-height: 16px;
		font-size: 12px;
		color: #ffffff;
		text-align: center;
		background: #f54531;
		border-radius: 9px;
		position: absolute;
		top: -6px;
		left: 12px;
		font-style: normal;
		border: 1px solid #fff;
	}
	.el-container .el-header .header_r .user{
		margin-right: 0;
	}
	.el-container .el-header .header_r .user .el-icon{
		margin-right: 0;
	}
	.el-container .el-header .header_r .user .logout {
		margin: 0 0 0 26px;
		cursor: pointer;
	}
	.el-container .container {
		height: calc(100% - 64px);
	}
	.el-container .container .el-aside {
		width: 208px;
		height: 100%;
		padding: 16px;
		box-sizing: border-box;
		color: #333333;
		background: #ffffff;
		font-size: 16px;
	}
	.el-container .container .main_wrap{
		width: calc(100% - 208px);
	}
	.el-container .el-main {
		width: 100%;
		padding: 24px;
		box-sizing: border-box;
		overflow: hidden;
	}
	@media screen and (max-width:1440px) {
		.el-container .container .el-aside {
			padding: 10px;
			font-size: 12px;
		}
	}
</style>